import LoginComponent from "../../components/Login";

import { useNavigate } from "react-router-dom";

//const Login = () => {
const Login = props => {
    console.warn('screens/Login(props)', props);

    //const [about, setLogin] = useState(null);
    const navigate = useNavigate()
    // useEffect(() => {
    //   axiosInstance.get('/webcontent?key=about_us').then((res) => {
    //     setLogin(res?.data?.result[0]);
    //   }).catch((err) => {
    //     PopUpAlert("Alert", err?.data?.response?.error ? err?.data?.response?.error : err.message, "error")
    //   })
    // }, []);
    const redirectNft = () => {
        navigate('/search/all')
    }

    return (
        
        <main
            //className = 'item-main edit-profile about'
            //className = 'sensei sensei-light'
            className = 'item-main register'
            >
            <section
                //className={styles.aboutsection}
                //className = 'form property-information'
                className = 'sensei sensei-light'
                //className = 'form'
                style = {{
                    paddingTop: "0px"
                    , paddingBottom: "80px"
                }}
                >
                <div
                    className = { 'max-width' }
                    style = {{ paddingLeft: '0px', paddingRight: '0px' }}
                    >
                    <div
                        //className = 'flex-container'
                        //className = { 'property-information' }
                        //style = {{ textAlign: "left" }}
                        style = {{
                            width: '100%'
                            , maxWidth: "440px"
                            , margin: 'auto'
                        }}
                        >
                        
                        <LoginComponent
                            keyDownUsername = { props.keyDownUsername }
                            keyDownPassword = { props.keyDownPassword }
                            showCloseButton = { false }
                            showLoginDialog = { props.showLoginDialog }
                            isModal = { false }
                            //loginUser = { props.loginUser }
                            loginUser2 = { props.loginUser2 }
                            loginPasswordRef = { props.loginPasswordRef }
                            loginFormRef = { props.loginFormRef }
                            loginError = { props.loginError }
                            setLoginError = { props.setLoginError }

                            clickForgotPassword = { props.clickForgotPassword }
                            clickRegister = { props.clickRegister }
                            handleLogin = { props.handleLogin }
                            handleLogin2 = { props.handleLogin2 }
                            usernameRef = { props.usernameRef }
                            passwordRef = { props.passwordRef }
                            />
                        
                    </div>
                </div>
            </section>

        </main>
        
    );
};

export default Login;
